import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";
import BettingPlace from "../../models/betting-places";
import { deleteItem } from "../../api/generics";

interface BettingPlaceDeleteModalProps {
  show: boolean;
  bettingPlace?: BettingPlace;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const BettingPlaceDeleteModal: React.FC<BettingPlaceDeleteModalProps> = ({
  show,
  bettingPlace,
  onCancel,
  onSuccess,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const message = bettingPlace
    ? `Está seguro de que quiere eliminar el lugar ${bettingPlace.name}`
    : "";

  const onDeleteClick = async () => {
    if (bettingPlace !== undefined) {
      setSubmitting(true);
      const placeStatus = await deleteItem<BettingPlace>(`/betting_places/${bettingPlace.id}/`, bettingPlace);

      if (placeStatus.status !== SUCCESS) {
        let message = "Ha ocurrido un error!!";
        if (placeStatus.detail !== undefined) {
          message = placeStatus.detail;
        }
        errorAlert(message);
      } else {
        onSuccess();
      }

      setSubmitting(false);
    }
  };

  return (
    <CModal show={show} className="modal-danger" onClosed={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>Eliminar</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow>
            <CCol sm="12">
              <h2>{message}</h2>
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton disabled={submitting} onClick={onDeleteClick} color="danger">
          {submitting ? (
            <Spinner
              animation="grow"
              style={{
                height: "17px",
                width: "17px",
                marginTop: "auto",
                marginBottom: "auto",
                marginRight: "10px",
              }}
            />
          ) : (
            <></>
          )}
          {submitting ? "Eliminando..." : "Eliminar"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default BettingPlaceDeleteModal;
